import { modelOptions, prop } from '@typegoose/typegoose';
import * as mongoose from 'mongoose';

class CompanyShort {
  @prop({ required: true })
  id: mongoose.Types.ObjectId;

  @prop({ required: true })
  name: string;
}

export class Target {
  @prop({ required: true })
  name: string;

  @prop({ required: false })
  path?: string;

  @prop({ required: true })
  type: number;

  @prop({ required: true })
  protectedEntityId: mongoose.Types.ObjectId;

  // When the company is a root type company (i.e the user is Bitdefender), this field is null
  @prop({ required: true, type: CompanyShort, default: null })
  company: CompanyShort;
}

export class ServiceTarget {
  @prop({ required: true })
  serviceId: number;

  @prop({ required: true, type: Target })
  targets: Array<Target>;
}

class UserRights {
  @prop({ required: true })
  manageCompanies: boolean;

  @prop({ required: true })
  manageInventory: boolean;

  @prop({ required: true })
  managePoliciesRead: boolean;

  @prop({ required: true })
  managePoliciesWrite: boolean;

  @prop({ required: true })
  manageUsers: boolean;

  @prop({ required: true })
  manageReports: boolean;

  @prop({ required: true })
  managePlatform: boolean;

  @prop({ required: true })
  companyManager: boolean;

  @prop({ required: true })
  manageRemoteShell: boolean;
}

class Role {
  @prop({ required: true, type: UserRights })
  rights: UserRights;
}

class TwoFactorAuthentication {
  @prop({ required: false })
  secret: string;

  @prop({ required: true })
  enabled: boolean;

  @prop({ required: false })
  mdrGracePeriod: number;
}

class Profile {
  @prop({ required: true })
  sessionTimeout: number; // minutes

  @prop({ required: true })
  fullName: string;

  @prop({ required: true })
  timezone: string;
}

@modelOptions({ schemaOptions: { collection: 'users' }, options: { customName: 'users' } })
export class Users {
  @prop({ required: true, _id: true })
  _id: mongoose.Types.ObjectId;

  @prop({ required: true })
  company: CompanyShort;

  @prop({ required: true, type: ServiceTarget })
  serviceTargets: Array<ServiceTarget>;

  @prop({ required: true, type: Role })
  role: Role;

  @prop({ required: true, type: TwoFactorAuthentication })
  twoFactorAuthentication: TwoFactorAuthentication;

  @prop({ required: true })
  userName: string;

  @prop({ required: false })
  mdrSuperAnalyst?: boolean;

  @prop({ required: true })
  source: number;

  @prop({ required: true })
  profile: Profile;
}
